import React from 'react';

const MongoDB_Delete = () => {
  return (
    <div>
      <h1>MongoDB_Delete Component</h1>
      <p>This is the MongoDB_Delete page.</p>
    </div>
  );
};

export default MongoDB_Delete;
